import axiosInstance from '@/shared/api/axios';
import type {
  ApiArrivedPackageDeliverBody,
  ApiArrivedPackageItem,
  ApiArrivedPackagesListParams,
  ApiArrivedPackagesListResponse,
  ApiArrivedParcelItem,
  ApiArrivedParcelsListParams,
  ApiArrivedParcelsListResponse,
  ApiWarehouseScanResponse,
} from '@/shared/types/api/warehouse-arrivals';

export const apiArrivedPackagesListGet = async (
  params: ApiArrivedPackagesListParams,
): Promise<ApiArrivedPackagesListResponse> => {
  const { data } = await axiosInstance.get<ApiArrivedPackagesListResponse>(
    '/warehouse/arrived-packages',
    {
      params,
    },
  );
  return data;
};

export const apiArrivedPackageGet = async (id: string): Promise<ApiArrivedPackageItem> => {
  const { data } = await axiosInstance.get<ApiArrivedPackageItem>(
    `/warehouse/arrived-packages/${id}`,
  );
  return data;
};

export const apiArrivedPackageDeliver = async (
  id: string,
  body: ApiArrivedPackageDeliverBody,
): Promise<ApiArrivedPackageItem> => {
  const { data } = await axiosInstance.post<ApiArrivedPackageItem>(
    `/warehouse/arrived-packages/${id}/deliver`,
    body,
  );
  return data;
};

export const apiWarehouseScanGet = async (
  uniqueId: string,
): Promise<ApiWarehouseScanResponse> => {
  const { data } = await axiosInstance.get<ApiWarehouseScanResponse>('/warehouse/scan', {
    params: { unique_id: uniqueId },
  });
  return data;
};

export const apiArrivedParcelsListGet = async (
  params: ApiArrivedParcelsListParams,
): Promise<ApiArrivedParcelsListResponse> => {
  const { data } = await axiosInstance.get<ApiArrivedParcelsListResponse>(
    '/warehouse/arrived-parcels',
    {
      params,
    },
  );
  return data;
};

export const apiArrivedParcelGet = async (id: string): Promise<ApiArrivedParcelItem> => {
  const { data } = await axiosInstance.get<ApiArrivedParcelItem>(
    `/warehouse/arrived-parcels/${id}`,
  );
  return data;
};
